import { gateway } from "../../../gateway";

export const acceptAdminInvitation = async (invitationUid: string) => {
  try {
    const response = await gateway.post(`/invitations/${invitationUid}/accept`);

    return response.data?.data;
  } catch (error) {
    console.error("Error sending admin invitation", error);
    throw error;
  }
};
